<template>
  <Modal v-model="isShow" width="65%" :closable="false" :mask-closable="false">
    <div slot="header" class="info-header">
      <div class="ivu-modal-header-inner">账单流水</div>
      <a class="ivu-modal-close" @click="closeModel"><i class="ivu-icon ivu-icon-ios-close"></i></a>
    </div>
    <div>
      <Form ref="tradeflowForm" :model="form" :label-width="80" :rules="ruleValidate">
        <Row>
          <Col span="8">
            <FormItem label="ID" prop="id">
              <Input v-model="form.id" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="订单号" prop="tradeNo">
              <Input v-model="form.tradeNo" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="账单类型" prop="billType">
              <Input v-model="form.billType" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="用户ID-身份证" prop="userId">
              <Input v-model="form.userId" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="交易流水" prop="flowNo">
              <Input v-model="form.flowNo" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="交易时间" prop="flowTime">
              <Input v-model="form.flowTime" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="交易类型" prop="flowType">
              <Input v-model="form.flowType" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="收支方向" prop="flowDirection">
              <Input v-model="form.flowDirection" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="付款方式" prop="flowCard">
              <Input v-model="form.flowCard" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="金额" prop="money">
              <Input v-model="form.money" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="商品说明" prop="counterparty">
              <Input v-model="form.counterparty" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="商家订单号" prop="merchantNo">
              <Input v-model="form.merchantNo" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="商品说明" prop="goodsDesc">
              <Input v-model="form.goodsDesc" :disabled="disable"></Input>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </div>
    <div slot="footer">
      <Button @click="closeModel">取消</Button>
      <Button type="primary" @click="submit"  v-show="!disable">提交</Button>
    </div>
  </Modal>
</template>

<script>

export default {
  name: 'tradeflow-info',
  data () {
    return {
      form: {},
      isShow: false,
      type: 'add',
      disable: false,
      ruleValidate: {
        id: [
          { required: true, message: 'ID不允许为空', trigger: 'blur' }
        ],
        tradeNo: [
          { required: true, message: '订单号不允许为空', trigger: 'blur' }
        ],
        billType: [
          { required: true, message: '账单类型不允许为空', trigger: 'blur' }
        ],
        userId: [
          { required: true, message: '用户ID-身份证不允许为空', trigger: 'blur' }
        ],
        flowNo: [
          { required: true, message: '交易流水不允许为空', trigger: 'blur' }
        ],
        flowTime: [
          { required: true, message: '交易时间不允许为空', trigger: 'blur' }
        ],
        flowType: [
          { required: true, message: '交易类型不允许为空', trigger: 'blur' }
        ],
        flowDirection: [
          { required: true, message: '收支方向不允许为空', trigger: 'blur' }
        ],
        flowCard: [
          { required: true, message: '付款方式不允许为空', trigger: 'blur' }
        ],
        money: [
          { required: true, message: '金额不允许为空', trigger: 'blur' }
        ],
        counterparty: [
          { required: true, message: '商品说明不允许为空', trigger: 'blur' }
        ],
        merchantNo: [
          { required: true, message: '商家订单号不允许为空', trigger: 'blur' }
        ],
        goodsDesc: [
          { required: true, message: '商品说明不允许为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    openModel (type, data) {
      this.isShow = true
      this.type = type
      if (data) {
        this.form = data
      } else {
        this.form = {}
      }
      this.disable = type === 'detail'
    },
    closeModel () {
      this.isShow = false
    },
    submit () {
      this.$refs.tradeflowForm.validate((valid) => {
        if (valid) {
          switch (this.type) {
            case 'create':
              this.C('tradeflow', this.form).then(data => {
                this.isShow = false
                this.$emit('handle-search')
              })
              break
            case 'update':
              this.U('tradeflow', this.form).then(data => {
                this.isShow = false
                this.$emit('handle-search')
              })
              break
          }
        } else {
          this.$Message.error('请检查填写的数据')
        }
      })
    }
  },
  mounted: function () {
  }
}
</script>
